exports.onClientEntry = () => {
    if (typeof window !== "undefined") {
        window.Buffer = window.Buffer || require("buffer").Buffer;
    }
};